import { useEffect, useRef } from 'react'

/**
 * useInterval
 * Runs a callback at the specified interval, with support for dynamic delay and latest closure access.
 * @param callback The function to run on each interval
 * @param delay Delay in ms. Pass `null` to pause.
 */
function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef<() => void>()
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (delay === null) return
    const tick = () => {
      savedCallback.current?.()
    }
    const id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}

export default useInterval
